// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"114":"49d8a33c","155":"5a46fc54","766":"5dea627c","781":"a3970a01"}[chunkId] + ".js";
};